import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { apiWalletTransactionsList } from 'Services/StoreUserService'
import { getFinancialYearDates } from 'Utils/helper'

export const getData = createAsyncThunk('storeUser/walletTransactions/getData', async datas => {
    const { data } = await apiWalletTransactionsList(datas)
    return data
})

export const getView = createAsyncThunk('storeUser/walletTransactions/getView', async id => {
    return viewData
})

const viewData = {
    types: 1,
    user_id: '',
    bank_account_id: '',
    unpaid_invoices: [],
    amount: '',
    description: '',
    type: '',
}

export const walletTransactionsSlice = createSlice({
    name: 'storeUser/walletTransactions',
    initialState: {
        loading: true,
        view: viewData,
        data: [],
        total: 0,
        table: {
            page: 1,
            length: 10,
            search: '',
            column: '',
            dir: '',
            ...getFinancialYearDates(),
            user_type: '',
            user_id: '',
        },
    },
    reducers: {
        setData: (state, { payload }) => {
            state.data = payload
        },
        setTableData: (state, { payload }) => {
            state.table = payload
        },
        setDate: (state, { payload: { start, end } }) => {
            state.table.page = 1
            state.table.start = start
            state.table.end = end
        },
        setUserType: (state, { payload }) => {
            state.table.page = 1
            state.table.user_type = payload
            state.table.user_id = ''
        },
        setUserId: (state, { payload }) => {
            state.table.page = 1
            state.table.user_id = payload
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getData.pending, state => {
                state.loading = true
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload.data
                state.total = payload.total
            })
            .addCase(getData.rejected, state => {
                state.loading = false
                state.data = []
                state.total = 0
            })
            .addCase(getView.pending, state => {
                state.loading = true
                state.view = viewData
            })
            .addCase(getView.fulfilled, (state, { payload }) => {
                state.loading = false
                state.view = payload
            })
    },
})

export const { setData, setTableData, setDate, setUserType, setUserId } = walletTransactionsSlice.actions

export default walletTransactionsSlice.reducer
